import { useQuery } from '@tanstack/react-query';
import { getProfileFull } from '@/api/inbox';
import { useProject } from '@/contexts/ProjectProvider';
import { useAuthStore } from '@/store/auth';
import { cwKeys } from '@/lib/cwCache';

/**
 * Сессия Переписок для активного проекта: номер кабинета, профиль Chatwoot (id и ключ событий)
 * и состоит ли человек в этом кабинете. Один запрос профиля обслуживает проверку доступа,
 * «я — это кто» для папки «Мои» и подписку на события.
 */
export function useCwSession() {
  const { status, projectId, chatwootAccountId } = useProject();
  const userId = useAuthStore((s) => s.user?.id ?? null);
  const ready = status === 'ready' && !!projectId && chatwootAccountId !== null && !!userId;

  const profile = useQuery({
    queryKey: cwKeys.profile(),
    enabled: ready,
    queryFn: getProfileFull,
    staleTime: 30 * 60_000,
  });

  const accountId = chatwootAccountId;
  const inAccount = !!profile.data && accountId !== null && profile.data.accounts.some((a) => a.id === accountId);
  return {
    accountId,
    ready,
    profile,
    myUserId: profile.data?.id ?? null,
    /** Можно ходить за данными кабинета. */
    enabled: ready && inAccount && accountId !== null,
    inAccount,
  };
}
